import React from 'react';
import { Box } from '@mui/material';
import { getCompareStatus, LINE_COMPARE_STATUS } from '../../helpers/stocktakeLineCompare';

export { getCompareStatus } from '../../helpers/stocktakeLineCompare';

const COLORS = {
  [LINE_COMPARE_STATUS.MATCH]: '#2e7d32',
  [LINE_COMPARE_STATUS.UNDER]: '#d32f2f',
  [LINE_COMPARE_STATUS.OVER]: '#1976d2',
};

const StocktakeCompareDot = ({ status, size = 24 }) => {
  if (!status) return null;
  const color = COLORS[status] || COLORS[LINE_COMPARE_STATUS.MATCH];
  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '50%',
        bgcolor: color,
      }}
    />
  );
};

export default StocktakeCompareDot;
